// extracted by mini-css-extract-plugin
export default {"searchBar":"BuManagerV2_searchBar__zkers"};